<template>
  <CContainer>
    <h2 v-if="title">{{ title }}</h2>
    <CForm>
      <template v-for="(field, index) in fields">

        <!-- Autocomplete component -->
        <CAutocomplete v-if="field.type === 'autocomplete'" 
          :label="field.label"
          :disabled="field.disabled==undefined ? false : field.disabled"
          :required="field.required==undefined ? false : field.required"
          :key="field.key"
          :options="field.options"
          :prepend_content="field.prepend_content"
          @update:input="(newValue) => {
            field.value = newValue
            field.update_input ? field.update_input(newValue) : null
          }"
          @update-search="(newValue) => field.update_search ? field.update_search(newValue) : null"
        />

        <!-- Input text component -->
        <!-- :isValid="field.required ? (field.custom_validation ? field.custom_validation(field.value) : field.value.length > 0) : null" -->
        <CInput v-if="field.type==='text'"
          addLabelClasses="text-muted font-weight-bold"
          :key="field.key"
          :label="field.label"
          :placeholder="field.placeholder"
          :disabled="field.disabled==undefined ? false : field.disabled"
          :required="field.required==undefined ? false : field.required"
          :value.sync="field.value"
          :isValid="field.custom_validation ? field.custom_validation(field.value) : (field.required ? field.value.length > 0 : null)"
          @change="(newValue) => field.on_change ? field.on_change(newValue) : null">
          <template v-if="field.prepend_content" #prepend-content>
            <template v-if="typeof field.prepend_content==='string'">
              {{ field.prepend_content }}
            </template>
            <template v-if="typeof field.prepend_content==='object'">
              <BCIcon 
                :name="field.prepend_content.name" 
                :type="field.prepend_content.type" 
              />
            </template>
          </template>
        </CInput>

        <CInput v-if="field.type==='password'"
          type="password"
          addLabelClasses="text-muted font-weight-bold" 
          :key="field.key"
          :disabled="field.disabled == undefined ? false : field.disabled"
          :required="field.required == undefined ? false : field.required"
          :value.sync="field.value"
          :isValid="field.required ? (field.custom_validation ? field.custom_validation(field.value) : field.value.length > 0) : null"
          :label="field.label"
          @change="(newValue) => field.on_change ? field.on_change(newValue) : null">
          <template v-if="field.prepend_content" #prepend-content>
            <template v-if="typeof field.prepend_content === 'string'">
              {{ prepend_content }}
            </template>
            <template v-if="typeof field.prepend_content === 'object'">
              <BCIcon 
                :type="field.prepend_content.type" 
                :name="field.prepend_content.name" 
              />
            </template>
          </template>
        </CInput>

        <CTextarea v-if="field.type === 'textarea'" 
          addLabelClasses="text-muted font-weight-bold" 
          :key="field.key"
          :disabled="field.disabled == undefined ? false : field.disabled"
          :required="field.required == undefined ? false : field.required"
          :value.sync="field.value"
          :isValid="field.required ? (field.custom_validation ? field.custom_validation(field.value) : field.value.length > 0) : null"
          :label="field.label"
          @change="(newValue) => field.on_change ? field.on_change(newValue) : null" >
          <template #prepend-content v-if="field.prepend_content">
            <template v-if="typeof field.prepend_content === 'string'">
              {{ prepend_content }}
            </template>
            <template v-if="typeof field.prepend_content === 'object'">
              <BCIcon 
                :type="field.prepend_content.type" 
                :name="field.prepend_content.name"
              />
            </template>
          </template>
        </CTextarea>

            <div v-if="field.type==='price'" 
              :key="field.key"
              class="form-group" 
              role="group">
              <label class="text-muted font-weight-bold">{{field.label}}</label>
              <div v-if="field.prepend_content" class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <template v-if="typeof field.prepend_content==='string'">
                      {{ field.prepend_content }}
                    </template>
                    <template v-if="typeof field.prepend_content==='object'">
                      <BCIcon 
                        :type="field.prepend_content.type" 
                        :name="field.prepend_content.name"
                      />
                    </template>
                  </span>
                </div>
                <input 
                  type="text"
                  class="form-control" 
                  v-mask="currencyMask"
                  v-model="pc[index]"
                  :disabled="field.disabled == undefined ? false : field.disabled"
                  :class="field.required ? (field.value > 0 ? 'is-valid' : 'is-invalid') : ''"
                  @change="(value) => {
                    setValuePrice(value, index)
                      field.on_change ? field.on_change(value) : null
                  }"
                  @blur="(value) => setValuePrice(value, index)"
                />
              </div>
              <div v-else>
                <input 
                  type="text"
                  class="form-control" 
                  v-mask="currencyMask"
                  v-model="pc[index]"
                  :disabled="field.disabled == undefined ? false : field.disabled"
                  :class="field.required ? (field.value > 0 ? 'is-valid' : 'is-invalid') : ''"
                  @change="(value) => {
                    setValuePrice(value, index)
                      field.on_change ? field.on_change(value) : null
                  }"
                  @blur="(value) => setValuePrice(value, index)"
                />
              </div>
            </div>

            <CInput v-if="field.type === 'date'" 
              addLabelClasses="text-muted font-weight-bold" 
              type="date"
              :key="field.key"
              :disabled="field.disabled == undefined ? false : field.disabled"
              :required="field.required == undefined ? false : field.required"
              :value.sync="field.value"
              :isValid="field.required ? (field.custom_validation ? field.custom_validation(field.value) : field.value.length > 0) : null"
              :label="field.label"
              @change="(newValue) => field.on_change ? field.on_change(newValue) : null" >
              <template v-if="field.prepend_content" #prepend-content>
                <template v-if="typeof field.prepend_content === 'string'">
                  {{ prepend_content }}
                </template>
                <template v-if="typeof field.prepend_content === 'object'">
                  <BCIcon 
                    :type="field.prepend_content.type" 
                    :name="field.prepend_content.name"
                  />
                </template>
              </template>
            </CInput>

            <CInput v-if="field.type === 'time'" 
              addLabelClasses="text-muted font-weight-bold" 
              type="time"
              :key="field.key"
              :disabled="field.disabled == undefined ? false : field.disabled"
              :required="field.required == undefined ? false : field.required"
              :value.sync="field.value"
              :isValid="field.required ? (field.custom_validation ? field.custom_validation(field.value) : field.value.length > 0) : null"
              :label="field.label"
              @change="(newValue) => field.on_change ? field.on_change(newValue) : null"
            >
              <template v-if="field.prepend_content" #prepend-content>
                <template v-if="typeof field.prepend_content==='string'">
                  {{ prepend_content }}
                </template>
                <template v-if="typeof field.prepend_content==='object'">
                  <BCIcon :type="field.prepend_content.type" :name="field.prepend_content.name"/>
                </template>
              </template>
            </CInput>

            <CSelect v-if="field.type === 'select'" 
              addLabelClasses="text-muted font-weight-bold" 
              :key="field.key"                    
              :label="field.label"
              :disabled="field.disabled == undefined ? false : field.disabled"
              :required="field.required == undefined ? false : field.required"
              :options="field.options"
              :prepend_content="field.prepend_content"
              :value.sync="field.value"
              :isValid="field.required ? (field.custom_validation ? field.custom_validation(field.value) : field.value.length > 0) : null"
              @update:input="(newValue) => {
                field.value = newValue
              }"
              @change="(newValue) => field.on_change ? field.on_change(newValue) : null"
            >
              <template v-if="field.prepend_content" #prepend-content>
                <template v-if="typeof field.prepend_content === 'string'">
                  {{ prepend_content }}
                </template>
                <template v-if="typeof field.prepend_content === 'object'">
                  <BCIcon 
                    :type="field.prepend_content.type" 
                    :name="field.prepend_content.name"
                  />
                </template>
              </template>
            </CSelect>

            <div v-if="field.type === 'switch'"
              class="my-2"
              :disabled="field.disabled == undefined ? false : field.disabled"
              :required="field.required == undefined ? false : field.required"
              :key="field.key">
              <span class="text-muted font-weight-bold">{{ field.label }}</span>
              <CSwitch 
                class="align-middle mx-2"
                color="dark"
                shape="pill"
                :checked.sync="field.value"
                @update:checked="nvalue => {
                  field.on_change ? field.on_change(nvalue) : null
                }"
              />
            </div>

        <!-- Input File component -->
        <div v-if="field.type === 'file'" class="mb-2" :key="field.key">
          <label class="text-muted font-weight-bold mr-2">{{ field.label }}</label>
          <CInputFile
            class="mb-1"
            :placeholder="field.value[0] ? field.value[0].name : 'Seleccione archivo...'"
            :custom="true"
            :isValid="field.required ? (field.custom_validation ? field.custom_validation(field.value) : field.value.length > 0) : null"
            @change="files => {
              field.value = files;
            }" >
          </CInputFile>
          <!-- <span class="small text-muted" v-if="field.value">{{ field.value[0].name }}</span> -->
        </div>
      </template>
    </CForm>
  </CContainer>
</template>
<script>
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'
  import CAutocomplete from './CAutocomplete'
  import BCIcon from './BCIcon'

  const currencyMask = createNumberMask({
    prefix: '',
    integerLimit: 12,
    allowDecimal: true,
    decimalSymbol: ',',
    thousandsSeparatorSymbol: '.',
    includeThousandsSeparator: true,
    allowNegative: false,
  })

  export default {
    props: {
      title: String,
      fields: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        currencyMask,
        pc: []
      }
    },
    components: {
      CAutocomplete,
      BCIcon
    },
    methods: {
      setValuePrice(value, index) {      
        setTimeout(() => {
            const replaced = value.target.value
                              .replace("$","")
                              .replaceAll(".","")
                              .replaceAll(",",".")
            const parsed = parseFloat(replaced)
            this.fields[index].value = parsed ? parsed : 0
          },
          100
        )
      }
    },
    mounted() {
      this.pc = this.fields.map(() => 0);
    }
  }
</script>